import React from "react";

import "../../assets/css/rating-template.css";
import { useDashboardContext } from "../../context/customhook/dashboardHook";

export default function RatingItem({ ratingtext, ratingId, isSelected }) {
  const { dashboardStates, setDashboardStates } = useDashboardContext();

  const ratingOnClick = async (selectedValue) => {
    const ratingData = dashboardStates.ratingdata.map((obj) => ({
      ...obj,
      isSelected: obj.id === selectedValue ? true : false,
    }));

    setDashboardStates((previousState) => {
      return {
        ...previousState,
        rating: selectedValue,
        parentQuestionId: null,
        childQuestionId: null,
        parentQuestiondata: null,
        childQuestiondata: null,
        showAdditionalFeedback: null,
        ratingdata: ratingData,
      };
    });
  };

  return (
    <button
      onClick={() => ratingOnClick(ratingId)}
      className={isSelected ? "rating-button-selected" : "rating-button"}
    >
      {ratingtext}
    </button>
  );
}
